exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-simplebar]{overflow:scroll;height:100%;-ms-overflow-style:none;scrollbar-width:none}[data-simplebar]::-webkit-scrollbar{display:none}.simplebar-scrollbar:before{background:#7f9dfe}.simplebar-scrollbar:hover:before{opacity:1}", ""]);

